import React, { useRef, useState } from "react";
import { toast } from "react-toastify";
import type { IYoutube } from "../../../../pages/Party/YoutubeMatchingInfo";
import ConfirmBtn from "../../../Button/ConfirmBtn";
import { Input } from "../../../Input/Input";
import AlertModal from "../../../Modal/AlertModal";
import { saveYoutubeUrlAllocation } from "./youtubeExtrainfoApi";

export default function YoutubeRoundAccountModal({ round, closeEvent, onSaved }: {
  round: IYoutube;
  closeEvent: () => void;
  onSaved: () => void;
}) {
  const [email, setEmail] = useState("");
  const [confirming, setConfirming] = useState(false);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");
  const savingRef = useRef(false);

  const confirm = async () => {
    if (savingRef.current) return;
    const nextEmail = email.trim();
    // if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(nextEmail)) {
    //   setError("변경할 계정을 이메일 형식으로 입력해 주세요.");
    //   return;
    // }
    if (nextEmail === round.yt_r_email?.trim()) {
      setError("현재 계정과 다른 계정을 입력해 주세요.");
      return;
    }
    const roundNumber = Number(round.yt_round);
    const status = Number(round.yt_r_status);
    if (!round.partyid || !round.uid || !Number.isInteger(roundNumber) || roundNumber < 1 || roundNumber > 12 || ![1, 2, 3].includes(status)) {
      setError("현재 회차 정보를 확인할 수 없습니다. 목록을 새로고침해 주세요.");
      return;
    }
    setError("");
    if (!confirming) {
      setConfirming(true);
      return;
    }
    savingRef.current = true;
    setSaving(true);
    try {
      const result = await saveYoutubeUrlAllocation({
        provider: round.provider ?? undefined,
        pid: String(round.partyid),
        uid: String(round.uid),
        email: nextEmail,
        round: roundNumber,
        r_status: status,
        r_link: round.yt_r_link ?? "",
      });
      if (result.email !== nextEmail || result.round !== roundNumber || result.r_status !== status) {
        throw new Error("회차계정 저장 결과를 확인할 수 없습니다.");
      }
    } catch {
      setError("회차계정 변경에 실패했습니다. 다시 시도해 주세요.");
      return;
    } finally {
      savingRef.current = false;
      setSaving(false);
    }
    toast.success("회차계정이 변경되었습니다.");
    onSaved();
  };

  return (
    <AlertModal
      title={confirming ? "해당 계정으로 현 라운드 계정을 변경할까요?" : "회차계정 변경"}
      desc={`${round.yt_round ?? "-"}회차`}
      pointDesc={
        <div style={{ display: "flex", flexDirection: "column", gap: "12px", overflowWrap: "anywhere" }}>
          <div>현재 계정: {round.yt_r_email || "-"}</div>
          {confirming ? (
            <div>변경 계정: {email.trim()}</div>
          ) : (
            <label htmlFor="youtube-round-account-email">
              변경 계정
              <Input
                id="youtube-round-account-email"
                type="email"
                autoFocus
                value={email}
                placeholder="변경할 이메일 입력"
                aria-invalid={Boolean(error)}
                aria-describedby={error ? "youtube-round-account-error" : undefined}
                onChange={(event) => {
                  setEmail(event.target.value);
                  setError("");
                }}
              />
            </label>
          )}
          {error && <span id="youtube-round-account-error" role="alert">{error}</span>}
        </div>
      }
      customCancelBtn={<ConfirmBtn btnText="취소" btnColor="white" isDisabled={saving} btnClickEvent={closeEvent} />}
      customConfirmBtn={
        <ConfirmBtn btnText={saving ? "저장 중…" : "확인"} btnColor="mint" isDisabled={saving} btnClickEvent={() => void confirm()} />
      }
    />
  );
}
